module.exports = __webpack_public_path__ + "media/images/ns-app-battery-icon-80-dc123978afe900426406042f62e0957c.svg";